module.exports = __webpack_public_path__ + "img/pass.c0c72c80.png";